(function () {
  'use strict';

  angular
    .module('component.delete-cart-item', [])

    .component('buttonDeleteCartItem', {
      bindings: {
        idLine: '<',
        btnClass: '@',
        designation: '@productDesignation',
        img: '<productImg',
        titleBtn: '@?',
        titleDeleteOk: '@?'
      },
      templateUrl: 'component.delete-cart-item.tpl',
      /* @ngInject */
      controller: ["ModalService", "AppService", function (ModalService, AppService) {
        var ctrl = this;

        ctrl.delete = function () {
          ModalService.show(
            '/Template/Cart/ModalDeleteConfirm',
            {
              action: function () {
                AppService.deleteLine(ctrl.idLine, ctrl.designation, ctrl.img, ctrl.titleDeleteOk, true);
              }
            },
            null,
            'deleteConfirmModalCtrl'
          );
        };
      }]
    });

})();
